import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { usePetitionActionsPageData } from '#src/app/pages/actions/pageContext';
import type { UserRecordingCapability } from '#src/app/pages/actions/shared/types';
import { useLoginState } from '#src/app/shared/hooks/session';
import { isAndroidWebview } from '#src/app/shared/utils/userAgent';

/**
 * Checks the user's account and browser state to determine whether they should be able to record a video.
 */
export const useUserRecordingCapability = (): UserRecordingCapability => {
	const utilityContext = useUtilityContext();
	const loginState = useLoginState();
	const {
		data: { hasSigned },
	} = usePetitionActionsPageData();

	const isUnsupportedBrowser = isAndroidWebview(utilityContext);
	if (isUnsupportedBrowser) {
		return 'unsupported-browser';
	}

	if (loginState === 'GUEST') {
		return 'guest-login';
	}

	if (!hasSigned) {
		return 'has-not-signed';
	}

	return 'capable';
};
